export enum SubscriptionStatus {
    Active = 1,
    Cancelled = 2,
    Finished = 3
}
